import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;

const LID_H = 0.8 * IN;
const LID_RIM_H = 0.35 * IN;
const TAPER = 0.5 * IN;
const HANDLE_W = 4 * IN;
const HANDLE_H = 2 * IN;

export function DormStorageBinSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        <StorageBinSide
          depth={depth}
          height={height}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
      </SchematicShell>
    );
  }

  const lidBottom = LID_RIM_H + LID_H;
  const bodyH = height - LID_H - LID_RIM_H;
  const upperFrac = 0.6;
  const lowerH = bodyH * (1 - upperFrac);
  const taperY = height - lowerH;
  const ridgeY = lidBottom + bodyH * upperFrac * 0.65;

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Lid rim top */}
      <Line
        x1={0}
        y1={LID_RIM_H}
        x2={width}
        y2={LID_RIM_H}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Lid bottom / body top */}
      <Line
        x1={0}
        y1={lidBottom}
        x2={width}
        y2={lidBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Ridge line */}
      <Line
        x1={0}
        y1={ridgeY}
        x2={width}
        y2={ridgeY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.5}
      />
      {/* Taper step */}
      <Line
        x1={TAPER}
        y1={taperY}
        x2={width - TAPER}
        y2={taperY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Taper verticals */}
      <Line
        x1={TAPER}
        y1={taperY}
        x2={TAPER}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={width - TAPER}
        y1={taperY}
        x2={width - TAPER}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}

function StorageBinSide({ depth, height, strokeColor, strokeWidth }) {
  const lidBottom = (0.35 + 0.8) * IN;
  const bodyH = height - 0.8 * IN - 0.35 * IN;
  const upperFrac = 0.6;
  const upperH = bodyH * upperFrac;
  const lowerH = bodyH * (1 - upperFrac);
  const taperY = height - lowerH;
  const handleTop = lidBottom + upperH * 0.55 - HANDLE_H / 2;
  const handleBot = handleTop + HANDLE_H;
  const handleLeft = (depth - HANDLE_W) / 2;
  const handleRight = handleLeft + HANDLE_W;

  return (
    <g>
      {/* Lid lines */}
      <Line
        x1={0}
        y1={0.35 * IN}
        x2={depth}
        y2={0.35 * IN}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={0}
        y1={lidBottom}
        x2={depth}
        y2={lidBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Handle recess */}
      <Line
        x1={handleLeft}
        y1={handleTop}
        x2={handleRight}
        y2={handleTop}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.5}
      />
      <Line
        x1={handleLeft}
        y1={handleBot}
        x2={handleRight}
        y2={handleBot}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.5}
      />
      <Line
        x1={handleLeft}
        y1={handleTop}
        x2={handleLeft}
        y2={handleBot}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.5}
      />
      <Line
        x1={handleRight}
        y1={handleTop}
        x2={handleRight}
        y2={handleBot}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.5}
      />
      {/* Taper */}
      <Line
        x1={TAPER}
        y1={taperY}
        x2={depth - TAPER}
        y2={taperY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={TAPER}
        y1={taperY}
        x2={TAPER}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={depth - TAPER}
        y1={taperY}
        x2={depth - TAPER}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </g>
  );
}

DormStorageBinSchematic.supportsSideViews = true;
